<template>
  <ListComponent title="Bulk Customer Invoice Logs" :totalCount="totalItems">
    <template #list>
      <v-row class="ma-0">
        <v-col cols="4" class="px-0 pt-0 pb-2">
          <!-- <v-text-field
            label="Search"
            outlined
            dense
            append-icon="mdi-magnify"
            clearable
            hide-details="auto"
            v-model="filters.search"
            @input="searchBranch"
          ></v-text-field> -->
        </v-col>

        <v-col
          v-if="totalItems > 0"
          cols="8"
          class="px-0 pt-0 pb-2 d-flex justify-end"
        >
          <Pagination
            :pageNo="pageNo"
            :totalItems="totalItems"
            :pageSize="itemsPerPage"
            @itemsPerPageChange="itemsPerPageChanged"
            @prevPage="prevPage"
            @nextPage="nextPage"
          />
        </v-col>

        <v-col cols="12" class="pa-0">
          <AgGridVue
            style="width: 100%; height: calc(100vh - 172px)"
            class="ag-theme-alpine"
            id="myGrid"
            :columnDefs="headers"
            :context="context"
            @grid-ready="onGridReady"
            :defaultColDef="defaultColDef"
            :grid-options="gridOptions"
            :suppressDragLeaveHidesColumns="true"
            :rowData="allInvoiceLogsList"
          ></AgGridVue>
        </v-col>
      </v-row>
    </template>
  </ListComponent>
</template>

<script>
import ListComponent from "@/components/General/ListComponent.vue";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/General/Pagination.vue";
import CustomHeader from "@/components/AgGridComponents/General/CustomHeader.vue";
import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";

export default {
  components: {
    ListComponent,
    agColumnHeader: CustomHeader,
    AgGridVue,
    Pagination,
  },

  data() {
    return {
      sorting: {},
      headers: [
        // {
        //   headerName: "Customer",
        //   field: "no_of_invoice",
        //   sortable: true,
        // },
        {
          headerName: "Branch",
          field: "request_body.branch",
          sortable: true,
        },
        {
          headerName: "Invoice Type",
          field: "request_body.invoice_type",
          sortable: true,
        },
        {
          headerName: "Invoice To Date",
          field: "request_body.invoice_to_date",
          sortable: true,
        },
        {
          headerName: "Invoice From Date",
          field: "request_body.invoice_from_date",
          sortable: true,
        },
        {
          headerName: "No Of Invoice",
          field: "no_of_invoice",
          sortable: true,
        },
        {
          headerName: "No Of DAs",
          field: "no_of_das",
          sortable: true,
        },
        {
          headerName: "Created by",
          field: "created_by",
          sortable: true,
        },
        {
          headerName: "Status",
          field: "status",
          sortable: true,
        },
      ],

      allInvoiceLogsList: [],

      // pagination vars
      pageNo: 1,
      itemsPerPage: 20,
      totalItems: 0,
      filters: {},

      // ag-grid vars
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        resizable: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },

      showBranchForm: false,
      isEditing: false,
      editBranchID: null,

      permissions: null,
    };
  },

  computed: {
    context() {
      return { parentComponent: this };
    },
    currentProfile() {
      if (JSON.parse(localStorage.getItem("userProfile"))) {
        return JSON.parse(localStorage.getItem("userProfile"));
      } else {
        return null;
      }
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },

  methods: {
    applyGridSort(key, type) {
      if (this.filters && !this.filters.ordering) {
        this.filters.ordering = [];
      }

      if (type == null) {
        delete this.sorting[key];
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(`-${key}`),
          1
        );
      } else if (type == "asc") {
        this.filters.ordering.push(key);
      } else if (type == "desc") {
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(key),
          1,
          `-${key}`
        );
      }
      if (this.filters.ordering.length == 0) {
        delete this.filters.ordering;
      }
      this.itemsPerPageChanged(20);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    searchBranch() {
      this.pageNo = 1;
      this.getBulkCustomerInvoiceLogsList();
    },
    itemsPerPageChanged(e) {
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getBulkCustomerInvoiceLogsList();
    },
    prevPage() {
      this.pageNo--;
      this.getBulkCustomerInvoiceLogsList();
    },
    nextPage() {
      this.pageNo++;
      this.getBulkCustomerInvoiceLogsList();
    },

    getBulkCustomerInvoiceLogsList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        offset: this.offset,
        limit: this.itemsPerPage,
        ...params,
        ...this.filters,
      };
      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }
      this.$api.customerInvoice
        .getBulkIvoiceLogsList(params)
        .then((res) => {
          this.allInvoiceLogsList = res.data;
          this.totalItems = res.count;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },

    addBranch() {
      this.editBranchID = null;
      this.isEditing = false;
      this.showBranchForm = true;
    },

    editBranch(id) {
      this.editBranchID = id;
      this.isEditing = true;
      this.showBranchForm = true;
    },
  },
  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("configuration");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(
          `/app/${
            localStorage.getItem("user_type")
              ? localStorage.getItem("user_type").toLowerCase()
              : "error"
          }`
        );
      } else {
        this.permissions = { ...permissions };
        this.getBulkCustomerInvoiceLogsList();
      }
    }
  },
};
</script>
